import { Component, Input, OnInit } from '@angular/core';


/**
   * Logger Factory
   * @namespace size: 
*/

@Component({
  selector: 'ute-signal-wifi',
  templateUrl: 'ute-signal-wifi.component.html'
})
export class UteSignalWifiComponent implements OnInit{

  @Input() signal: number;

  public powerSignal: string;

  constructor() {
    
  }

  ngOnInit(){
    if(this.signal){
      if(this.signal <= 0){
        this.powerSignal = 'empty';
      }  else if(this.signal <= 33 && this.signal > 0){
        this.powerSignal = 'low';
      } else if(this.signal > 33 && this.signal <= 66){
        this.powerSignal = 'medium';
      } else {
        this.powerSignal = 'high';
      }
    } else {
      this.powerSignal = 'empty';
    }
    
  }


}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-signal-wifi/ute-signal-wifi.component.ts